import React, { PropsWithChildren, useCallback, useState } from "react";

import { DirtyFormContext } from "./DirtyFormContext";
import { DirtyFormContextValue } from "./DirtyFormContextProvider.types";

export const DirtyFormContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [dirtyForms, setDirtyForms] = useState<Set<string>>(new Set());

  const registerDirtyForm = useCallback((id: string) => {
    setDirtyForms((prev) => new Set(prev).add(id));
  }, []);

  const unregisterDirtyForm = useCallback((id: string) => {
    setDirtyForms((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, []);

  const clearAllDirtyForms = useCallback(() => {
    setDirtyForms(new Set());
  }, []);

  const contextValue: DirtyFormContextValue = {
    registerDirtyForm,
    unregisterDirtyForm,
    clearAllDirtyForms,
    isDirty: dirtyForms.size > 0,
  };

  return <DirtyFormContext.Provider value={contextValue}>{children}</DirtyFormContext.Provider>;
};
